import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { debounceTime, distinctUntilChanged, take, tap } from 'rxjs';
import { AuthFlowService } from '../../../core/services/auth-wrapper/auth-flow.service';

@Component({
    selector: 'app-base-sso-redirect',
    changeDetection: ChangeDetectionStrategy.Eager,
    template:
        '<!-- This component serves as a base and does not render any content -->',
})
export abstract class BaseSsoRedirectComponent implements OnInit {
    constructor(
        protected readonly auth0Service: AuthService,
        protected readonly authFlowService: AuthFlowService,
        protected readonly router: Router,
    ) {}

    ngOnInit(): void {
        this.auth0Service.isAuthenticated$
            .pipe(
                debounceTime(1000), // Give some time for the authentication state to stabilize
                distinctUntilChanged(),
                take(1),
                tap((isAuthenticated: boolean) => {
                    if (isAuthenticated) {
                        this.router.navigate([this.getAuthenticatedRoute()]);
                    } else {
                        this.triggerLoginFlow();
                    }
                }),
            )
            .subscribe();
    }

    protected abstract getAuthenticatedRoute(): string;

    protected abstract triggerLoginFlow(): void;
}
